import { registerLocaleData } from '@angular/common';
import localeExtraPT from '@angular/common/locales/extra/pt';
import localePT from '@angular/common/locales/pt';

export class LocaleUtil {
  public static registerAppLocales(): void {
    registerLocaleData(localePT, 'pt', localeExtraPT);
  }
}
